import { AppFeature } from '../../types/AppConstants';
import { DataSyncProductStore, Product } from './DataSyncProductsStore';

export class DataSyncSourceProductStore extends DataSyncProductStore {
  private SOURCE_PRODUCTS = [
    {
      display_name: 'Content Marketing Platform',
      name: 'CMP',
      icon: '/assets/cmp.svg'
    },
    {
      display_name: 'OCP database',
      name: 'HUB',
      icon: '/assets/data_platform.svg'
    },
    {
      display_name: 'OCP App',
      name: 'HUB_APP',
      icon: '/assets/data_platform.svg'
    },
    {
      display_name: 'Optimizely Graph',
      name: 'CGR',
      icon: '/assets/content_graph.svg'
    }
  ];

  public getProductList(): Product[] {
    const products = this.SOURCE_PRODUCTS.map((product) => {
      return {
        text: product.display_name,
        value: product.name,
        iconPath: product.icon
      };
    });

    return products;
  }

  public getProduct(productName: string): Product | null {
    const product = this.SOURCE_PRODUCTS.find(
      (p) => p.name === productName
    );
    if (product) {
      return {
        text: product.display_name,
        value: product.name,
        iconPath: product.icon,
      };
    }
    return null;
  }

  protected getAppFeatureType(): string {
    return AppFeature.SOURCE_APP;
  }
}
